import React from "react";
import { Select, FormControl, InputLabel, FormHelperText } from "@mui/material";
import { Controller } from "react-hook-form";
import { forwardRef } from "react";

const ReactHookFormSelect = forwardRef((props, ref) => {
  return (
    <FormControl fullWidth error={props?.error}>
      <InputLabel id={"select-label" + props.id}>{props.title}</InputLabel>
      <Controller
        render={({ field }) => (
          <Select
            value={field.value}
            onChange={(e) => {
              field.onChange(e);
              props.onChange && props.onChange(e.target.value);
            }}
            size={props.size}
            inputRef={field.ref}
            fullWidth
            labelId={"select-label" + props.id}
            label={props.label}
            variant="outlined"
          >
            {props.children}
          </Select>
        )}
        name={props.id}
        control={props.control}
        defaultValue={props.defaultValue ?? ""}
      />
      {props?.error ? (
        <FormHelperText>{props?.helperText}</FormHelperText>
      ) : null}
    </FormControl>
  );
});
export default ReactHookFormSelect;
